<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link
        v-if="this.$store.getters.user != null"
        to="/dashboard"
        class="spedTitle navbar-brand"
        style="margin-left: 5%"
      >
        <img src="@/assets/logo.svg" width="45" height="45" alt="" />
        Special Data
      </router-link>
      <router-link
        v-else
        to="/Home"
        class="spedTitle navbar-brand"
        style="margin-left: 5%"
      >
        <img src="@/assets/logo.svg" width="45" height="45" alt="" />
        Special Data
      </router-link>
      <div style="border-left: 2px solid #01596F">&nbsp;</div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        v-if="!$route.path.includes('v2')"
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        style="margin-right: 5%;"
      >
        <!--<ul v-if="$store.getters.user != null" class="navbar-nav">
          <li class="nav-item">
            <router-link
              to="/dashboard"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('dashboard')
              }"
              >Dashboard</router-link
            >
          </li>
          <li class="nav-item" v-if="$canSeeAllTabs($store.getters.user.Permissions)">
            <router-link
              to="/students"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('students')
              }"
              >Students</router-link
            >
          </li>
          <li class="nav-item" v-if="$canSeeAllTabs($store.getters.user.Permissions)">
            <router-link
              to="/subjects"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('subjects')
              }"
              >Subjects</router-link
            >
          </li>
          <li class="nav-item" v-if="$canSeeAllTabs($store.getters.user.Permissions)">
            <router-link
              to="/manageTemplates"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('manageTemplates')
              }"
              >Templates</router-link
            >
          </li>
          <li class="nav-item" v-if="$canSeeAllTabs($store.getters.user.Permissions)">
            <router-link
              to="/archived"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('archived')
              }"
              >Archive</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              to="/help"
              class="nav-link spedSubtitle"
              v-bind:class="{
                'font-weight-bold': $route.path.includes('help')
              }"
              >Help</router-link
            >
          </li>
        </ul>
        <ul v-if="this.$store.getters.user != null" class="navbar-nav ml-auto">
          <li class="navItem">
            <span class="navbar-text"
              >{{ this.$store.getters.user.First_Name }}
              {{ this.$store.getters.user.Last_Name }}</span
            >
          </li>
          <li class="nav-item dropdown">
            <a
              role="button"
              class="nav-link dropdown-toggle"
              id="navDropDownLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="material-icons">settings</i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navDropDownLink"
            >
              <a href="#/preferences" class="dropdown-item">My Profile</a>
              <a
                v-if="
                  $store.getters.user.Organizations.some(o =>
                    $canSeeAccountSettings(
                      $store.getters.user.Permissions,
                      o.Account.Account_Id
                    )
                  )
                "
                href="#/manageaccount"
                class="dropdown-item"
              >
                My Account(s)
              </a>
              <a href="#/manageorganization" class="dropdown-item" v-if="$canSeeAllTabs($store.getters.user.Permissions)">
                My Organization(s)
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" href="#" v-on:click="signOut"
                >Sign Out</a
              >
            </div>
          </li>
        </ul>-->
      </div>
      <button
        v-if="this.$store.getters.user == null"
        class="btn btn-primary navbar-nav ml-auto"
        style="margin-right: 5%; padding: 5px;"
        type="button"
        v-on:click="$router.push({ name: 'signin' })"
      >
        Sign In
      </button>
      <button
        v-else
        class="btn btn-primary navbar-nav ml-auto"
        style="margin-right: 5%; padding: 5px;"
        type="button"
        v-on:click="signOut()"
      >
        Sign Out
      </button>
    </nav>
  </div>
</template>

<script>
//import { AmplifyEventBus } from 'aws-amplify-vue'
import Parse from "parse"
//import AWS from 'aws-sdk'

export default {
  name: "Navbar",
  data() {
    return {};
  },
  async mounted() {
    var view = this;
    var stopLoadingList = ["tutorials", "privacypolicy", "help"];
    view.$store.commit("resetUser");
    view.$store.commit("updateLoading", true);
    await Parse.User.currentAsync()
      .then(async user => {
        if (user != undefined) {
          view.$store.commit("updateUser", user);
          var lowercasePath = view.$route.path.toLowerCase();
          if (lowercasePath.includes("home") || view.$route.path == "/") {
            view.$router.push("dashboard");
          } else if (stopLoadingList.some(l => lowercasePath.includes(l))) {
            view.$store.commit("updateLoading", false);
          }
        } else if (window.location.href.includes("confirmuser")) {
          view.$store.commit("updateLoading", false);
        } else {
          this.$router.push("Home");
          view.$store.commit("updateLoading", false);
        }
      })
      .catch(err => {
        console.log(err);
        if (
          window.location.href.includes("confirmuser") ||
          window.location.href.includes("resetpassword")
        ) {
          view.$store.commit("updateLoading", false);
        } else {
          this.$router.push("Home");
          view.$store.commit("updateLoading", false);
        }
        view.$store.commit("updateLoading", false);
      });
  },

  methods: {
    signOut() {
      this.$router.push("Home");
      Parse.User.logOut();
      this.$store.commit("resetUser");
      this.$store.commit("updateLoading", false);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  cursor: pointer;
}

.navbar {
  padding: 1em;
  padding-bottom: 1em;
}

.Form__formSection___3tqxz {
  -webkit-box-shadow: 0px;
  box-shadow: 0px;
}
</style>
